import { render, staticRenderFns } from "./AseanFunding.vue?vue&type=template&id=03ff3502&scoped=true&"
import script from "./AseanFunding.vue?vue&type=script&lang=js&"
export * from "./AseanFunding.vue?vue&type=script&lang=js&"
import style0 from "./AseanFunding.vue?vue&type=style&index=0&id=03ff3502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff3502",
  null
  
)

export default component.exports